import { client } from '@citylytics/core-api-ts-client/client';
import { HTTP_HEADER } from '@citylytics/http/constants';
import { SKIP_AUTH_RETRY } from './core-api-client.constants.js';
import { hasSkipAuthRetryFlag, hasSkipAuthRetryMeta, shouldSkipUnauthorizedRetry, withHttpStatusCode, } from './core-api-client.utils.js';
function markSkipAuthRetry(request) {
    Object.defineProperty(request, SKIP_AUTH_RETRY, {
        value: true,
        configurable: true,
    });
}
/**
 * Points the generated client at core-api for a browser app. It knows nothing of the app's
 * session, language or router: the app passes in how to read the language and what to do when
 * the session is gone.
 */
export function setupCoreApiClient(params) {
    const { baseUrl, readLanguage, onSessionLost } = params;
    client.setConfig({
        baseUrl,
        credentials: 'include',
        fetch: async (input, init) => {
            const originalRequest = input instanceof Request ? input : new Request(input, init);
            const response = await globalThis.fetch(originalRequest);
            if (response.status === 401 &&
                !hasSkipAuthRetryFlag(originalRequest) &&
                !shouldSkipUnauthorizedRetry(originalRequest.url)) {
                onSessionLost();
            }
            return response;
        },
    });
    client.interceptors.request.use((request, options) => {
        request.headers.set(HTTP_HEADER.LANGUAGE, readLanguage());
        if (hasSkipAuthRetryMeta(options)) {
            markSkipAuthRetry(request);
        }
        return request;
    });
    client.interceptors.error.use((error, response) => withHttpStatusCode({ error, response }));
}
